/* src/app/components/participant-leads-list/participant-leads-list.component.css */
.ref-head-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.create-button {
  padding: 4px 5px;
}
.button-sec {
  margin-bottom: 8px;
}
.main {
  width: 96%;
  margin: auto;
}
h2 {
  font-size: 1.286rem;
}
.action {
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  font-style: italic;
  font-weight: 700;
  color: darkslategrey;
}
.table-style {
  width: 100%;
}

/* src/app/components/billing/ledger/ledger-list/ledger-list.component.css */
nz-collapse-panel {
  margin: 0 0 8px;
}
:host {
  --ledger-teal: #00504b;
  --ledger-teal-soft: #d6ece8;
  --ledger-green: #1f8a4c;
  --ledger-red: #c0392b;
  --ledger-ink: #1f2a2a;
  --ledger-muted: #6b7676;
  --ledger-border: #e5e9e9;
  --ledger-mono:
    "Roboto Mono",
    "SFMono-Regular",
    ui-monospace,
    "Consolas",
    monospace;
  --teal-head-text: #00504b;
  --teal-mid: #01796f;
  --teal-pale: #cff1ef;
  --teal-pale-border: #a8e0da;
  --meta-gray: #454545;
  --meta-value: #20242a;
  --lavender-tint: #bebdf575;
  --tile-green: #1e8a4c;
  --tile-red: #c0392b;
  --line-eee: #eee;
  --mono-font:
    "Cascadia Code",
    "Consolas",
    "Courier New",
    monospace;
}
.ledger-head.ppl-container-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.ledger-head__titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ledger-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.2;
}
.ledger-breadcrumb__link {
  color: var(--ledger-teal);
  font-weight: 600;
  text-decoration: none;
}
.ledger-breadcrumb__link:hover {
  text-decoration: underline;
}
.ledger-breadcrumb__sep {
  color: var(--ledger-muted);
}
.ledger-breadcrumb__current {
  color: var(--ledger-muted);
}
.ledger-title {
  margin: 0;
  color: var(--ledger-teal);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.15;
}
.ledger-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ledger-search__error {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  font-size: 0.786rem;
  font-weight: 600;
  color: var(--red, #c0392b);
  white-space: nowrap;
}
.ledger-search__label {
  color: var(--meta-gray);
  font-size: 0.857rem;
  font-weight: 600;
  white-space: nowrap;
}
.ledger-search__input {
  padding: 8px 12px;
  min-width: 200px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 0.9rem;
  color: var(--meta-value);
  background: #ffffff;
}
.ledger-search__input:focus {
  outline: 2px solid var(--teal-mid);
  outline-offset: 1px;
  border-color: var(--teal-mid);
}
.ledger-search__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  background: var(--teal-head-text);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ledger-search__btn:hover {
  background: var(--teal-mid);
}
.ledger-search__btn:focus-visible {
  outline: 2px solid var(--teal-mid);
  outline-offset: 2px;
}
.claim-card {
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid var(--ledger-border);
  border-radius: 16px;
  padding: 28px 32px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}
.claim-card:focus {
  outline: 2px solid var(--ledger-teal-soft);
  outline-offset: 2px;
}
.claim-card--flat {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 4px 0 0;
}
.claim-card__heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.claim-card__label {
  color: var(--ledger-ink);
  font-size: 1.5rem;
  font-weight: 700;
}
.claim-card__id {
  color: var(--teal-mid);
  font-family: var(--mono-font);
  font-size: 1.286rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.claim-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: var(--teal-pale);
  color: var(--teal-head-text);
  border: 1px solid var(--teal-pale-border);
  border-radius: 12px;
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.claim-card__icn {
  margin-top: 6px;
  color: var(--meta-gray);
  font-size: 0.857rem;
}
.claim-card__divider {
  margin: 16px 0;
  border: none;
  border-top: 1px solid var(--line-eee);
}
.claim-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  row-gap: 8px;
  column-gap: 24px;
}
.claim-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.claim-field__label {
  color: var(--meta-gray);
  font-size: 0.857rem;
  font-weight: 400;
}
.claim-field__value {
  color: var(--meta-value);
  font-size: 0.857rem;
  font-weight: 600;
  word-break: break-word;
}
.claim-field__value--mono {
  font-family: var(--mono-font);
  font-size: 0.786rem;
}
.claim-field__value--highlight {
  align-self: flex-start;
  background: #d9dcdc;
  padding: 1px 6px;
  border-radius: 4px;
}
.claim-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-top: 18px;
  max-width: 720px;
}
.stat-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid var(--line-eee);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}
.stat-card__label {
  align-self: flex-start;
  padding: 4px 6px;
  background: var(--lavender-tint);
  color: var(--meta-gray);
  border-radius: 4px;
  font-size: 0.714rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.stat-card__value {
  font-size: 1.571rem;
  font-weight: 600;
  line-height: 1;
}
.stat-card__value--billed {
  color: var(--teal-mid);
}
.stat-card__value--charges {
  color: var(--tile-green);
}
.stat-card__value--ar {
  color: var(--tile-red);
}
.stat-card__value--ar-clear {
  color: var(--teal-mid);
}
.net-ledger-section {
  width: 100%;
  margin-top: 8px;
}
.ledger-totals {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 4px;
}
.ledger-totals__item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  padding: 6px 12px;
  background: #ffffff;
  border: 1px solid var(--ledger-border);
  border-radius: 8px;
}
.ledger-totals__item--net {
  background: var(--ledger-teal-soft);
  border-color: var(--ledger-teal-soft);
}
.ledger-totals__label {
  color: var(--ledger-muted);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
}
.ledger-totals__item--net .ledger-totals__label {
  color: var(--ledger-teal);
}
.ledger-totals__value {
  color: var(--ledger-ink);
  font-family: var(--ledger-mono);
  font-size: 0.95rem;
  font-weight: 700;
  white-space: nowrap;
}
.ledger-totals__item--net .ledger-totals__value {
  color: var(--ledger-teal);
}
.cdr-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  padding: 4px 4px 16px;
}
.cdr-summary__item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.cdr-summary__label {
  color: var(--ledger-muted);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.6px;
}
.cdr-summary__value {
  color: var(--ledger-ink);
  font-family: var(--ledger-mono);
  font-size: 1rem;
  font-weight: 700;
  word-break: break-word;
}
.cdr-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background: #e7e7f5;
  color: #3a3a52;
  border-radius: 999px;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
}
.cdr-badge--accepted {
  background: #d8f3e3;
  color: var(--ledger-green);
}
.cdr-table {
  width: 100%;
  border-collapse: collapse;
}
.cdr-table th {
  text-align: left;
  padding: 8px 12px;
  color: var(--ledger-muted);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.6px;
  background: #f4f6f6;
  border-top: 1px solid var(--ledger-border);
  border-bottom: 1px solid var(--ledger-border);
}
.cdr-table td {
  padding: 8px 12px;
  color: var(--ledger-ink);
  font-size: 0.9rem;
  line-height: 1.3;
  border-bottom: 1px solid var(--ledger-border);
}
.cdr-table td:nth-child(3) {
  font-family: var(--ledger-mono);
  font-weight: 600;
  white-space: nowrap;
}
.cdr-table tbody tr:nth-child(even) {
  background: #f2faf7;
}
.ledger-empty-state {
  margin: 0;
  padding: 20px 4px;
  color: var(--ledger-muted);
  font-size: 0.95rem;
}
@media (max-width: 576px) {
  .claim-card {
    padding: 20px;
  }
}
/*# sourceMappingURL=ledger-list.component-YTKPDV2O.css.map */
